"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgTreeNodeSchema = exports.OrgNodeSchema = void 0;
const zod_1 = require("zod");
exports.OrgNodeSchema = zod_1.z.object({
    orgId: zod_1.z.number(),
    code: zod_1.z.string().nullable(),
    name: zod_1.z.string().nullable(),
    type: zod_1.z.string().nullable(),
    path: zod_1.z.string().nullable(),
    parentId: zod_1.z.number().nullable(),
    level: zod_1.z.number().nullable(),
    orderNumber: zod_1.z.number().nullable(),
});
exports.OrgTreeNodeSchema = exports.OrgNodeSchema.extend({
    children: zod_1.z.lazy(() => zod_1.z.array(exports.OrgTreeNodeSchema)),
});
